import { DirectionEnum } from "@/models/enums";
import { useBookingStore } from "@/store/booking";
import { computed, reactive } from "vue";
import useBookingCalendar from "./useBookingCalendar";

const today = new Date();
const year = today.getFullYear();
const month = today.getMonth() + 1;

const currentOutwardCalendarView = reactive({ year, month });
const currentReturnCalendarView = reactive({ year, month });

const sameYear = (d: DirectionEnum, year: number) => year === (d === DirectionEnum.Outward ? currentOutwardCalendarView.year : currentReturnCalendarView.year);
const sameMonth = (d: DirectionEnum, month: number) => month === (d === DirectionEnum.Outward ? currentOutwardCalendarView.month : currentReturnCalendarView.month);

const useCalendarNote = () => {
    const bookingStore = useBookingStore();
    const { calendarConfigOutward } = useBookingCalendar();

    const updateCalendarView = (d: DirectionEnum, year: number, month: number) => {
        if (d === DirectionEnum.Outward) {
            currentOutwardCalendarView.month = month;
            currentOutwardCalendarView.year = year;
        } else {
            currentReturnCalendarView.month = month;
            currentReturnCalendarView.year = year;
        }
    }

    const calendarNote = computed(() => {
        const outwardRoute = bookingStore.getRoute(DirectionEnum.Outward);
        const returnRoute = bookingStore.getRoute(DirectionEnum.Return);

        return calendarConfigOutward.value.calendarNotes.find(n => (sameYear(DirectionEnum.Outward, n.year)
            && sameMonth(DirectionEnum.Outward, n.month) && n.routes.includes(outwardRoute)) || (sameYear(DirectionEnum.Return, n.year)
                && sameMonth(DirectionEnum.Return, n.month) && n.routes.includes(returnRoute)))?.text;
    });

    return {
        calendarNote,
        updateCalendarView
    }
}

export default useCalendarNote;